// iCalendar (.ics) generator for 409A refresh reminders — emergent feature (S5). Framework-free.

import { parseIso, toIsoDate } from '@backsolve/shared-logic/dates';

function escapeIcsText(text: string): string {
  return text.replace(/\\/g, '\\\\').replace(/,/g, '\\,').replace(/;/g, '\\;').replace(/\n/g, '\\n');
}

function toIcsDate(iso: string): string {
  return iso.replace(/-/g, '');
}

/**
 * Build a valid RFC 5545 `.ics` calendar entry for a 409A valuation refresh
 * reminder `windowDays` (default 365) after the given valuation date.
 */
export function buildRefreshIcs(entityName: string, valuationDate: string, windowDays = 365): string {
  const start = parseIso(valuationDate);
  const eventIso = start
    ? new Date(Date.UTC(start.getUTCFullYear(), start.getUTCMonth(), start.getUTCDate() + windowDays))
    : parseIso(valuationDate);
  const eventDate = eventIso ? toIsoDate(eventIso) : valuationDate;

  const dtstamp = toIcsDate(toIsoDate(new Date()));
  const dtstart = toIcsDate(eventDate);
  const summary = escapeIcsText(`409A valuation refresh due — ${entityName}`);

  const lines = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//409a-calculator//refresh-reminder//EN',
    'BEGIN:VEVENT',
    `UID:409a-refresh-${dtstart}@409a-calculator`,
    `DTSTAMP:${dtstamp}`,
    `DTSTART;VALUE=DATE:${dtstart}`,
    `SUMMARY:${summary}`,
    'BEGIN:VALARM',
    'TRIGGER;VALUE=DATE-TIME:' + dtstart + 'T080000Z',
    'ACTION:DISPLAY',
    `DESCRIPTION:${summary}`,
    'END:VALARM',
    'END:VEVENT',
    'END:VCALENDAR',
  ];

  return lines.join('\r\n');
}
